<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (vm.preRequisite; as preRequisite) {
            <div class="results" [class.disabled]="preRequisite.isDisabled">
                <div class="results-prizes play-now">
                    <ds-card
                        class="results-prizes-block play-now-block mb-3"
                        [ngClass]="{ 'mobile-swipe-cb-height': isMobile }"
                        [elevated]="dsComponents?.dsCardStatic?.elevated"
                        [variant]="dsComponents?.dsCardStatic?.variant">
                        <div class="play-now-left-txt dis-i-blk">
                            @if (!vm.isDeposit) {
                                <div class="play-now-txt-light">
                                    {{ preRequisite.criteriaType }}
                                </div>
                            }
                            <div class="play-now-money">{{ preRequisite.depositTitle }}</div>
                            <div class="play-now-away" [innerHTML]="preRequisite.depositDescription | trustAsHtml"></div>
                        </div>
                        @if (vm.isDeposit && preRequisite.isCriteriaMet) {
                            <div class="cashback-completed wager-cashback-info">
                                <span class="theme-success-i text-success"> </span>
                                <span class="completed">
                                    {{ preRequisite.playNowText }}
                                </span>
                            </div>
                        }
                        @if (!preRequisite.isCriteriaMet) {
                            <div class="play-now-right-txt" grayoutStyle>
                                <a
                                    [onClickWebTracker]="{
                                        LabelEvent: vm.webAnalyticModel.page,
                                        ActionEvent: vm.isDeposit ? 'Deposit Now  - Click' : 'Play Now  - Click',
                                        LocationEvent: vm.webAnalyticModel.tab,
                                        EventDetails: vm.webAnalyticModel.promoId,
                                        URLClicked: vm.isDeposit ? '' : vm.playNow?.url,
                                    }"
                                    ds-button
                                    size="medium"
                                    variant="filled"
                                    kind="primary"
                                    [onClickOpenLink]="vm.playNow"
                                    [isCashierButton]="vm.isDeposit">
                                    {{ preRequisite.playNowText }}
                                </a>
                            </div>
                        }
                    </ds-card>
                </div>
            </div>
        }
    }
</ng-container>
